<div [ngClass]="{'bookmarkeddWindow-hamberg-icon': from === 'bookmarkeddWindow','menus-data':  from === 'window' || 'submit' || 'giftHome' || 'giftCheckOut',
'usersetting':  from === 'userSetting'}">
    <a *ngIf="from === 'window'"><img class="profile-avatar" src="{{ profilePicture }}" /></a>
    <a *ngIf="from === 'giftHome'"><img class="profile-avatar-giftHome" src="{{ profilePicture }}" /></a>
    <a *ngIf="from === 'giftCheckOut'"><img class="profile-avatar-giftCheckOut" src="{{ profilePicture }}" /></a>
    <a *ngIf="from === 'submit'"><img class="profile-avatar-submit" src="{{ profilePicture}}" /></a>
    <a *ngIf="from === 'submit-1'"><img class="profile-avatar-submit" src="{{ constants.USER_ICON }}" /></a>
    <a *ngIf="from === 'userSetting'" class="notmobileView"><img class="profile-avatar-blue"
            src="{{ profilePicture }}" /></a>
    <a *ngIf="from === 'userSetting'" class="mobileView"><img class="profile-avatar mobileViewWidth"
            src="{{ profilePicture }}"></a>
    <a *ngIf="from === 'bookmarkeddWindow'"><img class="profile-avatar" src="{{ constants.USER_ICON }}" /></a>
    <div [ngClass]="{
        'menu': isPrime,
        'setting-Prime': from === 'userSetting' && isPrime,
        'setting-notPrime':from === 'userSetting' && !isPrime,
        'menu-notPrime': !isPrime,
        'submit-menu':from === 'submit',
        'giftHome':from === 'giftHome',
        'giftCheckOut':from === 'giftCheckOut' 
      }">
        <div [ngClass]="isMapsearchResult ? 'windowMenu': 'user-menu'">
            <ul>
                <li>
                    <a [routerLink]="['/Window']" routerLinkActive="active-link">{{constants.MENU_ITEMS.WINDOW_VIEWS}}</a>
                </li>
                <li>
                    <a [routerLink]="['/submit']" routerLinkActive="active-link">{{
                        constants.MENU_ITEMS.SUBMIT_WINDOW
                        }}</a>
                </li>
                <!-- <li *ngIf="from === 'userSetting'"><a [routerLink]="['/Window']">{{constants.WINDOW_VIEWS}}</a></li> -->
                <li>
                    <a [routerLink]="['/user/mywindow']" routerLinkActive="active-link">{{
                        constants.MENU_ITEMS.MY_WINDOW
                        }}</a>
                </li>
                <li>
                    <a [routerLink]="['/user']" routerLinkActive="active-link">{{
                        constants.MENU_ITEMS.MYBOOKMARK
                        }}</a>
                </li>
                <li>
                    <a [routerLink]="['/user/tipjar']" routerLinkActive="active-link">{{
                        constants.MENU_ITEMS.MY_TIPSJAR
                        }}</a>
                </li>
                <li><a [routerLink]="['/sendGift']" routerLinkActive="active-link">Gift WindowSwap</a></li>
                <li>
                    <a [routerLink]="['/user-setting']" routerLinkActive="active-link">{{constants.MENU_ITEMS.SETTINGS}}</a>
                </li>
                <li (click)="Takemetoprime()" id="menu-item" *ngIf="!isPrime">
                    <button class="menu-submit-button">
                        {{ constants.MENU_ITEMS.GET_ALL_ACCESS }}
                    </button>
                </li>
                <li *ngIf="isPrime">
                <hr class="user-menu-line" />
                </li>
                <li>
                    <button class="user-logout" (click)="logout()">
                        {{ constants.MENU_ITEMS.LOGOUT }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>